import React, { useState, } from 'react';

import { useRouter } from 'next/router';
import UseModal from 'hooks/use-modal';


import { MOBILE_SLIDE_UP } from '@core/constants/ModalTypes';
import { planOptions } from 'constants/plans.const.js';

import ActionButton from '@core/components/actionbutton/ActionButton';
import Modal from '@core/components/Modal/Modal';
import SubscriptionPaymentWrapper from './payment/SubscriptionPaymentWrapper';
import PlanPrice from './plancard/PlanPrice';
import PeriodSelector from './plancard/PeriodSelector';

import classes from './OurPlans.module.scss';
import SubscriptionPaymentStepper from 'components/pages/plans/payment/subscriptionpaymentstepper/SubscriptionPaymentStepper';

const OurPlans = ({ data, isLoggedIn, toast }) => {
    const router = useRouter();
    const [period, setPeriod] = useState('Annual');
    const { show, showModal, destroyModal } = UseModal(false);
    const selectPlanHandler = () => {
        if (isLoggedIn) {
            showModal();
        }
        else
            router.push('/login?next=' + router.asPath);
    };
    return (
        <>
            <section className={`${classes['wrapper']}`}>
                <div className='container'>
                    <div className='row flex-column align-items-center justify-content-center'>
                        <h1>Advance your career with <span className={classes['primary-color']}>Pharmuni</span><span className={classes['warning-color']}> Premium</span></h1>
                        <p>
                            Gain essential skills and knowledge in the pharmaceutical industry with Pharmuni Premium, providing the tools you
                            need to master GMP, Quality Management Systems, and compliance. Choose your plan and begin your journey today!
                        </p>
                        <PeriodSelector period={period} setPeriod={setPeriod} />
                    </div>
                    <div className="row mt-5 d-flex flex-md-row flex-column-reverse justify-content-center">
                        <div className="col-md-6 col-12 d-flex justify-content-center justify-content-md-end">
                            <article className={`${classes['paln-card']} ${classes['free']}`}>
                                <div className={classes['price']}>
                                    Free
                                </div>
                                {isLoggedIn === false ? (
                                    <ActionButton kind='secondary_main_light' onClick={() => router.push('/login?next=/user-dashboard')}>
                                        Select Plan
                                    </ActionButton>
                                ) : (
                                    <div className={classes['has-plan']}>
                                        You already have this plan
                                    </div>
                                )}

                                <ul className='px-3 px-md-4'>
                                    {planOptions.free.map((option) =>
                                        <li>{option.description}</li>
                                    )}
                                </ul>
                            </article>
                        </div>
                        <div className={`col-md-6 col-12 d-flex justify-content-center justify-content-md-start mb-4 mb-md-0`}>
                            <div className={`${classes['card-wrapper']} ${(period === 'Annual' && data.yearly.number_of_months_saved && data.yearly.number_of_months_saved !== 0) && classes['has-promo']} `}>
                                <div className={classes['year-promo']}>
                                    {(period === 'Annual' && data.yearly.number_of_months_saved && data.yearly.number_of_months_saved !== 0) && (
                                        <>
                                            <span>Pay for {12 - data.yearly.number_of_months_saved} months, get 1 year </span>
                                            <div className={classes['pop-badge']}>Most Popular</div>
                                        </>
                                    )}
                                </div>
                                <article className={`${classes['paln-card']}`}>
                                    <PlanPrice period={period} data={data} />
                                    <ActionButton kind='secondary_main_light' onClick={selectPlanHandler}>
                                        Select Plan
                                    </ActionButton>
                                    <ul>
                                        {planOptions.premium.map((option) =>
                                            <li>{option.description}</li>
                                        )}
                                    </ul>
                                </article>
                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center">
                        <p>Subscription prices include VAT where applicable </p>
                    </div>
                </div>
            </section>
            <Modal
                type={MOBILE_SLIDE_UP}
                title=""
                show={show}
                closeHandler={destroyModal}
                header={true}
            >
                {/* <div className={classes['payment-modal']}>
                    <SubscriptionPaymentWrapper
                        closeHandler={destroyModal}
                        toast={toast}
                        period={period}
                        setPeriod={setPeriod}
                    />
                </div> */}
                <SubscriptionPaymentStepper
                    closeHandler={destroyModal}
                    toast={toast}
                    period={period}
                    setPeriod={setPeriod}
                />
            </Modal>
        </>
    );
};

export default OurPlans;